import React from 'react';
import RequestSummaryList from '../../components/RequestSummaryList';
import RequestNameListItem from '../../containers/RequestNameListItem';

const TaskSummaryList = ({ category, code }) => (
  <RequestSummaryList category={category} code={code}>
    <RequestNameListItem code={code} category={category} />
  </RequestSummaryList>
);

export default TaskSummaryList;
